import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
    id_libro:         Yup.string().required('El libro es obligatorio'),
    id_curso_escolar: Yup.string().required('El año es obligatorio'),
})

export default validationSchema